<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-5"> </p>
<p class="DED"><span class="HPh1_Highlighted_phrase_1">F</span>or all the <span class="HPh4_Highlighted_phrase_4">fr</span>iends who walked by my side through<span class="HPh3_Highlighted_phrase_3"> lockdown.</span></p>
<p class="DED"><span class="HPh1_Highlighted_phrase_1">A</span>nd especially <span class="HPh4_Highlighted_phrase_4">fo</span>r Jo; to paraphrase Robert Burns, ‘we twa hae paiddled in the sea and pu’d the ramsons <span class="HPh4_Highlighted_phrase_4">fi</span>ne; we’ll tak a richt guidwillie waught <span class="HPh4_Highlighted_phrase_4">fo</span>r auld l<span class="HPh3_Highlighted_phrase_3">ang syne.’</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802159038-4.vue?3c163c3c